import { GET_MY_STUDENT } from "constants/students";

export default (state = {}, action) => {
  switch (action.type) {
    case `${GET_MY_STUDENT}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
